import { EntityModificationTrace, Matrix } from "@wizeoo/akm-message-lib";
import { ViewData } from '../../model/view.data';

/**
 * objet porteur du pack de matrices de données chargées
 */
export class MatrixDataLoad {
  public static PENDING: string = 'PENDING';
  public static LOADING: string = 'LOADING';
  public static COMPLETE: string = 'COMPLETE';

  public domain: string; // pour contrôle de cohérence sur chargement
  public bu: string; // pour contrôle de cohérence sur chargement
  public uniqueKey: string; // domain|bu

  public state: string = MatrixDataLoad.PENDING; // l'état de chargement de ce pool

  public revisionNumber: number = -1; // dernier numRev local
  public nbMatrix: number = 0; // nombre de matrices de données
  public nbDeleteds: number = 0; // nombre de suppressions de matrices de données
  
  public localMatrix: Map<string, Matrix> = new Map(); // les matrices de données stockées en indexDB

  public remoteRevisionNumber: number = -1; // le numRev remote, retourné lors du count

  public matrix: Matrix[] = []; // les matrices de données à charger

  public deletedMatrix: EntityModificationTrace[]; // EMs de suppression sur les matrices de données
  public callbacks: Function[] = []; //  fonctions de retour, va renvoyer les localMatrix (matrix: Matrix[]) => void; // 

  public matrixCode: string = null; // pour appel sur une seule matrice de données avant commit, pour contrôle d'intégrité

  constructor(domain: string, bu: string, matrixCode ?: string) {
    this.domain = domain;
    this.bu = bu;
    this.matrixCode = matrixCode;
    this.uniqueKey = [domain,bu].join(ViewData.KEY_SEPARATOR);
   }

   public toPersist: Map<string, Matrix> = null;
   public toDie: Map<number, EntityModificationTrace> = null;

}
